<script lang="ts">export let className = "";
</script>

<svg
	width="32"
	height="32"
	viewBox="0 0 52 51"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
	class={className}
>
	<g filter="url(#filter0_d_5500_47398)">
		<path
			d="M8.48436 32.4916C8.77258 31.1465 8.00399 29.8976 6.85111 28.7447C5.98645 27.88 5.21786 26.9193 4.64142 25.7664C3.9689 24.2292 3.9689 22.6921 4.73749 21.2509C5.21786 20.3863 5.89037 19.7138 6.46681 18.9452C6.65896 18.753 6.85111 18.4648 7.04326 18.2727C8.00399 17.3119 8.29221 16.159 8.38829 14.9101C8.38829 13.9494 8.38829 12.8925 8.58043 11.9318C9.0608 9.4339 10.7901 7.89672 13.3841 7.51243C14.0566 7.41635 14.6331 7.51243 15.3056 7.41635C16.1702 7.32028 16.9388 7.32028 17.7074 7.12813C18.2839 6.93598 18.7642 6.55169 19.2446 6.1674C19.6289 5.87917 19.9171 5.49488 20.2053 5.20666C22.8954 2.5166 26.4501 2.5166 29.1402 5.11059C29.4284 5.39881 29.7166 5.68703 29.9088 5.87917C30.8695 6.93598 32.1185 7.32028 33.4635 7.32028C34.4242 7.32028 35.385 7.32028 36.2496 7.51243C38.9397 8.08887 40.4769 9.72212 40.7651 12.9886C40.7651 13.469 40.7651 14.0454 40.7651 14.5258C40.7651 16.2551 41.3415 17.6002 42.5905 18.753C44.1277 20.0981 45.0884 21.7313 44.9923 23.941C44.8962 25.4782 44.1277 26.8232 43.0709 27.9761C42.7826 28.2643 42.5905 28.5525 42.3023 28.7447C41.2455 29.7054 40.8612 30.9544 40.8612 32.2994C40.8612 33.2601 40.8612 34.317 40.669 35.2777C40.0926 37.9678 37.979 39.601 35.2889 39.6971C34.8085 39.6971 34.3282 39.6971 33.8478 39.6971C32.2145 39.601 30.8695 40.0814 29.6205 41.3303C29.1402 41.8107 28.5637 42.2911 27.9873 42.7714C25.7776 44.4047 23.4718 44.5008 21.2621 42.9636C20.3014 42.2911 19.5328 41.5225 18.6682 40.7539C17.8996 40.0814 17.131 39.7931 16.0742 39.7931C15.4017 39.7931 14.7291 39.7931 14.0566 39.6971C13.4802 39.601 12.9998 39.601 12.4234 39.4089C10.598 39.0246 9.4451 37.8717 8.77258 36.1424C8.58043 35.2777 8.48436 34.1248 8.48436 32.4916ZM16.3624 30.3779C16.3624 30.8583 16.5545 31.5308 17.5153 31.9151C18.2839 32.2033 18.8603 32.2033 19.5328 31.6269C19.725 31.4347 19.9171 31.2426 20.1093 31.0505C21.7425 29.4172 23.3758 27.6879 25.009 26.0546C27.5069 23.5567 30.0048 21.0588 32.5028 18.4648C32.791 18.1766 33.0792 17.7923 33.1753 17.3119C33.3674 16.5433 32.9831 15.6787 32.2145 15.2944C31.4459 14.9101 30.5813 15.0062 29.9088 15.6787C28.7559 16.8316 27.603 17.9844 26.4501 19.1373C23.2797 22.3078 20.1093 25.4782 16.9388 28.6486C16.6506 29.0329 16.3624 29.5133 16.3624 30.3779ZM22.5111 17.2159C22.5111 14.814 20.5896 12.8925 18.1878 12.8925C15.786 12.8925 13.8645 14.814 13.8645 17.2159C13.8645 19.6177 15.786 21.5392 18.1878 21.5392C20.5896 21.5392 22.5111 19.6177 22.5111 17.2159ZM31.9263 25.8625C29.5245 25.8625 27.603 27.784 27.603 30.1858C27.603 32.5876 29.5245 34.5091 31.9263 34.5091C34.3282 34.5091 36.2496 32.5876 36.2496 30.1858C36.2496 27.784 34.2321 25.8625 31.9263 25.8625Z"
			fill="url(#paint0_linear_5500_47398)"
		/>
		<path
			d="M33.3666 30.1868C33.3666 30.9554 32.6941 31.6279 31.9255 31.6279C31.1569 31.6279 30.4844 30.9554 30.4844 30.1868C30.4844 29.4182 31.1569 28.7457 31.9255 28.7457C32.6941 28.7457 33.3666 29.4182 33.3666 30.1868Z"
			fill="url(#paint1_linear_5500_47398)"
		/>
		<path
			d="M19.6303 17.2165C19.6303 17.9851 18.9577 18.6576 18.1892 18.6576C17.4206 18.6576 16.748 17.9851 16.748 17.2165C16.748 16.4479 17.4206 15.7754 18.1892 15.7754C19.0538 15.7754 19.6303 16.4479 19.6303 17.2165Z"
			fill="url(#paint2_linear_5500_47398)"
		/>
	</g>
	<defs>
		<filter
			id="filter0_d_5500_47398"
			x="-0.642857"
			y="-0.833333"
			width="51.7143"
			height="51.7732"
			filterUnits="userSpaceOnUse"
			color-interpolation-filters="sRGB"
		>
			<feFlood flood-opacity="0" result="BackgroundImageFix" />
			<feColorMatrix
				in="SourceAlpha"
				type="matrix"
				values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
				result="hardAlpha"
			/>
			<feOffset dx="1.21429" dy="2.02381" />
			<feGaussianBlur stdDeviation="2.42857" />
			<feComposite in2="hardAlpha" operator="out" />
			<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.33 0" />
			<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5500_47398" />
			<feBlend
				mode="normal"
				in="SourceGraphic"
				in2="effect1_dropShadow_5500_47398"
				result="shape"
			/>
		</filter>
		<linearGradient
			id="paint0_linear_5500_47398"
			x1="24.7544"
			y1="4.71001"
			x2="24.7544"
			y2="44.0589"
			gradientUnits="userSpaceOnUse"
		>
			<stop stop-color="var(--color-primary-100)" />
			<stop offset="1" stop-color="var(--color-primary-500)" />
		</linearGradient>
		<linearGradient
			id="paint1_linear_5500_47398"
			x1="31.9382"
			y1="28.8537"
			x2="31.9382"
			y2="31.6279"
			gradientUnits="userSpaceOnUse"
		>
			<stop stop-color="var(--color-primary-100)" />
			<stop offset="1" stop-color="var(--color-primary-500)" />
		</linearGradient>
		<linearGradient
			id="paint2_linear_5500_47398"
			x1="18.2019"
			y1="15.8834"
			x2="18.2019"
			y2="18.6576"
			gradientUnits="userSpaceOnUse"
		>
			<stop stop-color="var(--color-primary-100)" />
			<stop offset="1" stop-color="var(--color-primary-500)" />
		</linearGradient>
	</defs>
</svg>
